export const HYPERLINK_CONTEXT_INTENT_ID_ATTR = 'data-contextintentid';
//# sourceMappingURL=web-chat-constants.js.map